var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "promotions" },
    [
      _c(
        "Transition",
        [
          _c(
            "b-carousel",
            _vm._b(
              {
                attrs: {
                  background: _setup.backgroundColor,
                  fade: "",
                  controls: "",
                },
                on: { "sliding-end": _setup.onSlideEnd },
                model: {
                  value: _setup.slide,
                  callback: function ($$v) {
                    _setup.slide = $$v
                  },
                  expression: "slide",
                },
              },
              "b-carousel",
              { interval: _setup.interval, imgHeight: _setup.imgHeight },
              false
            ),
            _vm._l(_setup.promos, function (promo) {
              return _c(
                "b-carousel-slide",
                { key: promo.id, staticClass: "promotion-slide" },
                [
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(promo.displayText) +
                        "\n\n          "
                    ),
                    promo.action
                      ? _c("span", { staticClass: "link" }, [
                          _c("a", { on: { click: promo.action } }, [
                            _vm._v("Info"),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }